import PicklistMetadata from "../PicklistMetadata";

// Where a referenced secret lives. Ours is AWS -- Secrets Manager or SSM Parameter Store --
// where Ataccama offers HashiCorp Vault; the idea, storing the name rather than the value, is the
// same.
class ConnectionCredentialSecretProviderPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ConnectionCredentialSecretProvider";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Connection Credential Secret Provider";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default ConnectionCredentialSecretProviderPicklistMetadata;
